
export enum CorrectionAction {

  REPLACE,

  DELETE
}
